import React from 'react';
import {Header, Icon, Modal, Select} from 'semantic-ui-react';
import XLSX from 'xlsx';
import {Actions} from '../../../../common/actions';
import {useDispatch} from 'react-redux';

const {fetchValidateVehiclesColors} = Actions;

const ConfirmationModal = ({
  showConfirmation,
  setShowConfirmation,
  options,
  acceptedFile,
  navigateTo,
}) => {
  const dispatch = useDispatch();
  const optionsList = options.map((option, index) => ({
    'key': index,
    'value': index,
    'text': option,
  }));

  const columns = ['katashiki', 'sfx', 'model', 'start_date', 'end_date', 'currency', 'fob', 'outdoor_color',
    'outdoor_color_desc', 'indoor_color', 'indoor_color_desc', 'color_value', 'commision', 'shipping_cost', 'cif',
  ];
  const handleDropFile = (acceptedFile, index) => {
    const reader = new FileReader();
    reader.onload = (evt) => {
      const bstr = evt.target.result;
      const wb = XLSX.read(bstr, {'type': 'binary'});
      const wsname = wb.SheetNames[index];
      const ws = wb.Sheets[wsname];
      const data = XLSX.utils.sheet_to_json(ws, {'header': columns, 'range': 2});
      dispatch(fetchValidateVehiclesColors(data));
    };
    reader.readAsBinaryString(acceptedFile[0]);
    setShowConfirmation(false);
  };

  return (
    <Modal
      basic
      onClose={() => setShowConfirmation(false)}
      onOpen={() => setShowConfirmation(true)}
      open={showConfirmation}
      size='small'
    >
      <Header icon>
        <Icon name='file alternate outline' />
        Escoja la hoja de excel que contiene la información que desea subir.
      </Header>
      <Modal.Content>
        <Select fluid
          selection
          placeholder='Seleccionar'
          options={optionsList}
          onChange={(e, {value}) =>
            handleDropFile(acceptedFile, value)
          }
        />
      </Modal.Content>
    </Modal>
  );
};

export default ConfirmationModal;
